import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthProvider";
import { useChosenDepartment } from "../../contexts/ChosenDepartment";
import { useSnackbar } from "../../contexts/SnackbarContext";
import { useErrorSnackbar } from "../../hooks/useErrorSnackbar";
import { backendService } from "../../services/backend.service";

export const useMissingUsersCount = () => {
	const { chosenDepartment } = useChosenDepartment();
	const { userInfo } = useAuth();

	return useQuery({
		queryKey: ["missingUsersCount", chosenDepartment.department_id],
		queryFn: async () => {
			const result = await backendService.getMissingUsersCount(chosenDepartment.department_id);
			return result.data.count;
		},
		enabled: !!chosenDepartment?.department_id && !!userInfo?.support,
	});
};

export const useCreateUsersForDepartment = () => {
	const { chosenDepartment } = useChosenDepartment();
	const showErrorSnackbar = useErrorSnackbar();
	const { userInfo } = useAuth();
	const { showSnackbar } = useSnackbar();

	return useMutation({
		mutationKey: ["createUsersForDepartment", chosenDepartment.department_id],
		mutationFn: async () => {
			if (!chosenDepartment || !userInfo || !userInfo.support) {
				showErrorSnackbar("You do not have permission to perform this action.", {
					chosenDepartment,
					userInfo,
				});
			}
			const result = await backendService.createUsersForDepartment(chosenDepartment.department_id);
			if (result.status === 200 || result.status === 201) {
				return result.data;
			}
			showErrorSnackbar("Failed to create users for the department.", result);
		},
		onError: (error) => {
			showErrorSnackbar("An error occurred while creating users for the department.", error);
		},
		onSuccess: () => {
			showSnackbar("Successfully created missing users for the department.", "success");
		},
	});
};
